import React from 'react';
import classNames from 'classnames';
import { RenderMarkdownMarked } from 'components/Atoms/RenderMarkdownMarked/RenderMarkdownMarked';
import styles from './SecondaryText.module.scss';

interface Props {
  text?: string;
  /** Drops the standalone margins when the caller (BlockHeading) owns the spacing. */
  flush?: boolean;
  /**
   * Renders sanitized markdown and links instead of literal text (ENG-4763: an accordion
   * description links out to resources).
   */
  markdown?: boolean;
}

/**
 * The optional secondary line of text beneath a block heading (ENG-4399), read from the
 * content-level `description` translation key.
 *
 * Renders nothing at all when unset so a block whose field was left blank produces no empty
 * container or stray spacing. Plain text by default — the value is not passed through a markdown
 * renderer, so stored markup stays literal — unless the caller opts into `markdown`.
 */
export function SecondaryText(props: Props) {
  const { text, flush, markdown } = props;

  if (!text?.trim()) {
    return null;
  }

  const className = classNames(styles.secondaryText, { [styles.flush]: flush });

  if (markdown) {
    return <RenderMarkdownMarked text={text} sanitize className={className} />;
  }

  return <p className={className}>{text}</p>;
}
